import classNames from "classnames";
import React, { useState } from "react";

interface IOption {
	label: string;
	value: string;
	isDisabled?: boolean;
}

interface TabPickerProps {
	options: IOption[];
	defaultValue?: string;
	onChange?: (selectedValue: string) => void;
}

const TabPicker = ({ options, defaultValue, onChange }: TabPickerProps) => {
	const [selectedTab, setSelectedTab] = useState<string>(
		defaultValue || (options.length > 0 ? options[0].value : "")
	);

	const handleTabChange = (value: string) => {
		setSelectedTab(value);
		if (onChange) {
			onChange(value);
		}
	};

	return (
		<div className="flex items-center p-1 bg-white rounded-lg shadow space-x-1">
			{options.map((option) => (
				<button
					key={option.value}
					disabled={option.isDisabled}
					onClick={() => handleTabChange(option.value)}
					className={classNames(
						`
            lg:px-4 px-2 py-1  lg:py-1.5 text-[12px] lg:text-sm font-medium rounded-md transition-colors duration-150 ease-in-out
            focus:outline-none
            ${
							selectedTab === option.value
								? "bg-blue-500 text-white shadow-md" //  selected button
								: "bg-white text-gray-700 hover:bg-gray-50" //  non-selected buttons
						}
          `,
						{ "pointer-events-none": option.isDisabled }
					)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
};

export default TabPicker;
